import React, { useState, useEffect } from 'react';
import { FormGenerator } from '@hwm/ui-lib';
import { ChannelUnitsModel, DigitalIntervalOptionsType, GraphExportType, PreferencesFormModel } from '@shared/models';
import { useFormikContext } from 'formik';
import { graphPreferencesFieldsConfiguration } from './GraphPreferences.utils';
import { isEmpty } from 'lodash';

interface GraphPreferencesProps {
  unitPreferencesOptions: Record<string, ChannelUnitsModel[]>;
  graphExports: GraphExportType[];
  digitalIntervals: DigitalIntervalOptionsType[];
  cumulativeModes: DigitalIntervalOptionsType[];
}

export const GraphPreferences: React.FC<GraphPreferencesProps> = ({
  unitPreferencesOptions,
  graphExports,
  digitalIntervals,
  cumulativeModes,
}) => {
  const formikProps = useFormikContext<PreferencesFormModel>();
  const { values } = formikProps ?? {};

  const [type, setType] = useState('');

  useEffect(() => {
    if (!type && values.graphUnitPreferences && !isEmpty(values.graphUnitPreferences)) {
      setType(Object.keys(values.graphUnitPreferences)?.[0]);
    }
  }, [type, values.graphUnitPreferences]);

  return (
    <div>
      <FormGenerator
        {...formikProps}
        fieldsConfiguration={graphPreferencesFieldsConfiguration(
          type,
          setType,
          unitPreferencesOptions,
          graphExports,
          digitalIntervals,
          cumulativeModes
        )}
        formDisabled={false}
        newEditableLook
        dataTestId="preferences-graph-form"
      />
    </div>
  );
};
